/*
 * Disney bags product template (templates/product.disney-bags.json).
 *
 * - Gallery (snippets/mm-disney-gallery.liquid): thumbnails move the phone carousel, the carousel marks its
 *   thumbnail, and a photo opens the theme's PhotoSwipe viewer on every photo.
 * - Options (sections/mm-disney-product.liquid): picking a value selects its variant for the theme's
 *   <product-form>, updates the label and the URL, and swaps the price and payment lines from the section.
 * - Feature slider (sections/mm-disney-features.liquid): prev and next arrows, dots, and an auto slide that stops
 *   when a visitor uses it and starts again after the resume delay; never with reduced motion.
 * - Related (sections/mm-disney-related.liquid): the tagged products, then the best sellers collection, closest
 *   price first, in a row the arrows page by whole cards.
 *
 * Every section includes this file, so it runs its setup once.
 */
(function () {
  'use strict';

  if (window.mmDisneyLoaded) {
    return;
  }
  window.mmDisneyLoaded = true;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reduceMotionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollBehaviour() {
    return reducedMotion ? 'auto' : 'smooth';
  }

  // The scrollLeft that puts an item at the track's start edge (its scroll padding included)
  function itemScrollLeft(track, item) {
    var padding = parseFloat(window.getComputedStyle(track).scrollPaddingLeft) || 0;
    var max = track.scrollWidth - track.clientWidth;
    return Math.max(0, Math.min(item.offsetLeft - padding, max));
  }

  // Index of the item whose start is nearest the current scroll position
  function nearestIndex(track, items) {
    var best = 0;
    var bestDistance = Infinity;
    items.forEach(function (item, index) {
      var distance = Math.abs(itemScrollLeft(track, item) - track.scrollLeft);
      if (distance < bestDistance - 1) {
        best = index;
        bestDistance = distance;
      }
    });
    return best;
  }

  /* ---------------------------------------------------------------- Gallery */

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-mm-dis-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-mm-dis-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-mm-dis-thumb]'));
    var links = Array.prototype.slice.call(gallery.querySelectorAll('[data-mm-dis-zoom]'));
    var frame = null;

    function markThumb(index) {
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: itemScrollLeft(track, slide), behavior: scrollBehaviour() });
      markThumb(index);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-mm-dis-thumb'), 10) || 0);
      });
    });

    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        markThumb(nearestIndex(track, slides));
      });
    }, { passive: true });

    links.forEach(function (link, index) {
      link.addEventListener('click', function (event) {
        var element = document.querySelector('.pswp');
        if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined' || !element) {
          return; // the link opens the full photo instead
        }
        event.preventDefault();
        var items = links.map(function (item) {
          return {
            src: item.getAttribute('href'),
            msrc: item.getAttribute('data-msrc'),
            w: parseInt(item.getAttribute('data-w'), 10) || 1200,
            h: parseInt(item.getAttribute('data-h'), 10) || 1200
          };
        });
        var viewer = new PhotoSwipe(element, PhotoSwipeUI_Default, items, {
          index: index,
          maxSpreadZoom: 2,
          loop: false,
          history: false,
          closeOnScroll: false,
          showHideOpacity: true,
          captionEl: false,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        });
        viewer.listen('afterChange', function () {
          if (window.matchMedia('(max-width: 767px)').matches) {
            goTo(viewer.getCurrentIndex());
          }
        });
        viewer.init();
      });
    });

    gallery.mmGoToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
          goTo(i);
          return;
        }
      }
    };
  }

  /* ---------------------------------------------------------------- Options */

  function initOptions(section) {
    var options = section.querySelector('[data-mm-dis-options]');
    if (!options) return;

    var dataNode = options.querySelector('[data-mm-dis-variants]');
    var variants = [];
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var sectionId = section.getAttribute('data-section');
    var productUrl = section.getAttribute('data-url');
    var form = document.getElementById('product-form-' + sectionId);
    var button = section.querySelector('[data-mm-dis-add]');
    var strings = (window.theme && window.theme.variantStrings) || {};
    var fieldsets = Array.prototype.slice.call(options.querySelectorAll('fieldset'));
    var request = 0;

    function selectedValues() {
      return fieldsets.map(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function setButton(variant) {
      if (!button) return;
      var label = button.querySelector('.single-add-to-cart-button--text');
      var available = variant && variant.available;
      button.disabled = !available;
      button.classList.toggle('sold-out', !available);
      if (label) {
        label.textContent = !variant ? (strings.unavailable || 'Unavailable') : available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      }
    }

    function refreshFromSection(variant) {
      var ticket = ++request;
      fetch(productUrl + '?variant=' + variant.id + '&section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (text) {
          if (ticket !== request) return;
          var html = new DOMParser().parseFromString(text, 'text/html');
          ['price-' + sectionId, 'pay-' + sectionId].forEach(function (id) {
            var source = html.getElementById(id);
            var target = document.getElementById(id);
            if (source && target) target.innerHTML = source.innerHTML;
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    options.addEventListener('change', function () {
      var values = selectedValues();

      fieldsets.forEach(function (fieldset, i) {
        var label = fieldset.querySelector('.form__label__value');
        if (label) label.textContent = values[i] || '';
      });

      var variant = variants.filter(function (candidate) {
        return candidate.options.every(function (value, i) {
          return values[i] === value;
        });
      })[0];

      setButton(variant);
      if (!variant) return;

      if (form) {
        var input = form.querySelector('input[name="id"]');
        if (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);

      var gallery = section.querySelector('[data-mm-dis-gallery]');
      if (gallery && gallery.mmGoToMedia && variant.featured_media) {
        gallery.mmGoToMedia(variant.featured_media.id);
      }

      refreshFromSection(variant);
    });
  }

  /* ---------------------------------------------------------- Feature slider */

  // Ported from OzMobiles' assets/photo-text-rows.js. Card left edges and the snap line are in track coordinates.
  // Returns the scrollLeft that puts the next (or previous) card on the snap line, or null when there is none.
  function targetScrollLeft(cardLefts, scrollLeft, snapPadding, direction) {
    var snapLine = scrollLeft + snapPadding;
    var i;

    if (direction > 0) {
      for (i = 0; i < cardLefts.length; i++) {
        if (cardLefts[i] > snapLine + 1) return cardLefts[i] - snapPadding;
      }
      return null;
    }

    for (i = cardLefts.length - 1; i >= 0; i--) {
      if (cardLefts[i] < snapLine - 1) return Math.max(0, cardLefts[i] - snapPadding);
    }
    return null;
  }

  // Where the auto slide goes next: the next card (the browser clamps the last step to the end), or back to the
  // start once the track is at its end
  function autoplayScrollLeft(cardLefts, scrollLeft, snapPadding, maxScroll) {
    if (scrollLeft >= maxScroll - 1) return 0;
    var left = targetScrollLeft(cardLefts, scrollLeft, snapPadding, 1);
    return left === null ? 0 : Math.min(left, maxScroll);
  }

  // Every scrollLeft the track can rest at, one per dot: each card on the snap line, clamped to the end, so cards
  // that cannot reach the snap line share the final stop
  function stopPositions(cardLefts, snapPadding, maxScroll) {
    var positions = [];
    cardLefts.forEach(function (left) {
      var position = Math.min(Math.max(0, left - snapPadding), Math.max(0, maxScroll));
      if (!positions.length || position - positions[positions.length - 1] > 1) positions.push(position);
    });
    return positions;
  }

  function nearestStop(positions, scrollLeft) {
    var nearest = 0;
    for (var i = 1; i < positions.length; i++) {
      if (Math.abs(positions[i] - scrollLeft) < Math.abs(positions[nearest] - scrollLeft)) nearest = i;
    }
    return nearest;
  }

  function snapPaddingOf(track) {
    return parseFloat(window.getComputedStyle(track).scrollPaddingLeft) || 0;
  }

  function prefersReducedMotion() {
    return Boolean(reduceMotionQuery && reduceMotionQuery.matches);
  }

  /*
   * - The arrows (Vision's carousel buttons, shown from 768px) bring the next or previous slide to the start of the
   *   track; the one at either end is disabled, which mm-disney.css hides.
   * - The dots mark the slide in view and jump on a click; they are rebuilt when the number of stops differs.
   * - Auto slide, when the section carries data-autoplay (seconds between slides): the next slide, back to the
   *   first after the last. A click, a press, a swipe, a sideways scroll, a key or focus moving into the slider
   *   stops it, and it slides again once data-resume seconds pass without another. It waits while less than half
   *   of the slider is on screen, the tab is hidden or the theme editor holds a block, and never runs for visitors
   *   who ask for reduced motion.
   * - Every photo loads once the slider reaches the screen, so no slide brings in an empty frame.
   */
  function initFeatures(section) {
    if (section.hasAttribute('data-mm-dis-ready')) return;

    var track = section.querySelector('[data-mm-dis-features-track]');
    var prev = section.querySelector('[data-mm-dis-prev]');
    var next = section.querySelector('[data-mm-dis-next]');
    var dots = section.querySelector('[data-mm-dis-dots]');
    if (!track || !prev || !next) return;

    section.setAttribute('data-mm-dis-ready', '');

    var frame = 0;
    var cleanups = [];
    var stops = [];

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(function () {
        target.removeEventListener(type, handler, options);
      });
    }

    function cardLefts() {
      return Array.prototype.map.call(track.children, function (card) {
        return card.offsetLeft - track.firstElementChild.offsetLeft;
      });
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function updateDots(max) {
      if (!dots) return;

      var positions = stopPositions(cardLefts(), snapPaddingOf(track), max);

      if (positions.length !== dots.children.length) {
        dots.textContent = '';
        positions.forEach(function (position, index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'mm-dis-features__dot';
          dot.setAttribute('aria-controls', track.id);
          dot.setAttribute('aria-label', 'Slide ' + (index + 1) + ' of ' + positions.length);
          dots.appendChild(dot);
        });
      }

      stops = positions;
      dots.hidden = stops.length < 2;

      var current = nearestStop(stops, track.scrollLeft);
      Array.prototype.forEach.call(dots.children, function (dot, index) {
        if (index === current) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function update() {
      frame = 0;
      var max = maxScroll();
      var scrollable = max > 1;
      section.setAttribute('data-mm-dis-scrollable', scrollable ? 'true' : 'false');
      prev.disabled = !scrollable || track.scrollLeft <= 1;
      next.disabled = !scrollable || track.scrollLeft >= max - 1;
      updateDots(max);
    }

    function scheduleUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function step(direction) {
      var left = targetScrollLeft(cardLefts(), track.scrollLeft, snapPaddingOf(track), direction);
      if (left !== null) track.scrollTo({ left: left, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }

    listen(prev, 'click', function () { step(-1); });
    listen(next, 'click', function () { step(1); });

    if (dots) {
      listen(dots, 'click', function (event) {
        var dot = event.target.closest('.mm-dis-features__dot');
        var index = dot ? Array.prototype.indexOf.call(dots.children, dot) : -1;
        if (index >= 0 && stops[index] !== undefined) {
          track.scrollTo({ left: stops[index], behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        }
      });
    }

    listen(track, 'scroll', scheduleUpdate, { passive: true });

    var resizeObserver = null;
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(track);
    } else {
      listen(window, 'resize', scheduleUpdate);
    }

    // Auto slide

    var interval = parseFloat(section.getAttribute('data-autoplay')) * 1000 || 0;
    var resumeDelay = parseFloat(section.getAttribute('data-resume')) * 1000 || 0;
    var slideTimer = 0;
    var resumeTimer = 0;
    var stoppedByVisitor = false;
    var heldByEditor = false;
    var onScreen = false;
    var touching = false;
    var intersectionObserver = null;

    function canSlide() {
      return interval > 0 && !stoppedByVisitor && !heldByEditor && onScreen && !document.hidden &&
        !prefersReducedMotion() && maxScroll() > 1;
    }

    // A full interval from now before the next slide, or none when sliding is not allowed now
    function restartCountdown() {
      window.clearTimeout(slideTimer);
      slideTimer = canSlide() ? window.setTimeout(slide, interval) : 0;
    }

    function slide() {
      slideTimer = 0;
      if (!canSlide()) return;
      track.scrollTo({ left: autoplayScrollLeft(cardLefts(), track.scrollLeft, snapPaddingOf(track), maxScroll()), behavior: 'smooth' });
      restartCountdown();
    }

    // The visitor used the slider: stop, and slide again once resumeDelay passes with no further use
    function stopForVisitor() {
      stoppedByVisitor = true;
      window.clearTimeout(slideTimer);
      window.clearTimeout(resumeTimer);
      slideTimer = 0;
      resumeTimer = window.setTimeout(function () {
        resumeTimer = 0;
        stoppedByVisitor = false;
        slide();
      }, resumeDelay);
    }

    if (interval > 0) {
      listen(section, 'click', stopForVisitor);
      listen(section, 'keydown', stopForVisitor);
      listen(section, 'focusin', stopForVisitor);
      listen(section, 'pointerdown', function (event) {
        if (event.pointerType !== 'touch') stopForVisitor();
      });

      listen(track, 'wheel', function (event) {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || (event.shiftKey && event.deltaY)) stopForVisitor();
      }, { passive: true });

      // A swipe: the track scrolls while a finger is on it. A finger that only scrolls the page moves no track.
      listen(track, 'touchstart', function () { touching = true; }, { passive: true });
      listen(track, 'touchend', function () { touching = false; }, { passive: true });
      listen(track, 'touchcancel', function () { touching = false; }, { passive: true });
      listen(track, 'scroll', function () {
        if (touching) stopForVisitor();
      }, { passive: true });

      listen(document, 'visibilitychange', restartCountdown);

      if (reduceMotionQuery && reduceMotionQuery.addEventListener) {
        listen(reduceMotionQuery, 'change', restartCountdown);
      }

      listen(section, 'shopify:block:select', function () {
        heldByEditor = true;
        restartCountdown();
      });
      listen(section, 'shopify:block:deselect', function () {
        heldByEditor = false;
        restartCountdown();
      });
    }

    // The browser's lazy loading starts a photo only as it slides into view, so an arrow or the auto slide would
    // bring in an empty frame
    function loadAllPhotos() {
      Array.prototype.forEach.call(track.querySelectorAll('img[loading="lazy"]'), function (image) {
        image.loading = 'eager';
      });
    }

    if (window.IntersectionObserver) {
      intersectionObserver = new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        var wasOnScreen = onScreen;
        if (entry.isIntersecting) loadAllPhotos();
        onScreen = entry.intersectionRatio >= 0.5;
        if (onScreen !== wasOnScreen) restartCountdown();
      }, { threshold: [0, 0.5, 1] });
      intersectionObserver.observe(track);
    } else {
      loadAllPhotos();
      onScreen = true;
      restartCountdown();
    }

    section.mmDisDestroy = function () {
      window.clearTimeout(slideTimer);
      window.clearTimeout(resumeTimer);
      window.cancelAnimationFrame(frame);
      if (resizeObserver) resizeObserver.disconnect();
      if (intersectionObserver) intersectionObserver.disconnect();
      cleanups.forEach(function (cleanup) { cleanup(); });
    };

    update();
  }

  /* ----------------------------------------------------------------- Related */

  // Ported from OzMobiles' assets/ranked-related-products.js. Prev and next page through the cards by whole cards:
  // next brings the first card cut off on the right to the start, prev goes back by as many cards as fit. The
  // button at either end is disabled, which mm-disney.css hides, so both are hidden when every card fits.
  function setupRelatedArrows(root) {
    var scroller = root.querySelector('[data-mm-dis-related-list]');
    var prev = root.querySelector('[data-mm-dis-prev]');
    var next = root.querySelector('[data-mm-dis-next]');
    var frame = 0;
    if (!scroller || !prev || !next) return;

    function update() {
      frame = 0;
      var max = scroller.scrollWidth - scroller.clientWidth;
      var scrollable = max > 1;
      root.setAttribute('data-mm-dis-scrollable', scrollable ? 'true' : 'false');
      prev.disabled = !scrollable || scroller.scrollLeft <= 1;
      next.disabled = !scrollable || scroller.scrollLeft >= max - 1;
    }

    function scheduleUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function step(direction, button) {
      if (button.disabled) return;

      var origin = scroller.getBoundingClientRect().left - scroller.scrollLeft;
      var cards = Array.prototype.map.call(scroller.children, function (card) {
        var rect = card.getBoundingClientRect();
        return { left: rect.left - origin, right: rect.right - origin };
      });
      if (!cards.length) return;

      var inset = cards[0].left;
      var target = null;
      var i;

      if (direction > 0) {
        var viewEnd = scroller.scrollLeft + scroller.clientWidth;
        for (i = 0; i < cards.length; i++) {
          if (cards[i].right > viewEnd + 1) {
            target = cards[i].left - inset;
            break;
          }
        }
        if (target === null) target = scroller.scrollWidth;
      } else {
        var wanted = scroller.scrollLeft - (scroller.clientWidth - inset);
        for (i = 0; i < cards.length; i++) {
          if (cards[i].left - inset >= wanted - 1) {
            target = cards[i].left - inset;
            break;
          }
        }
      }

      scroller.scrollTo({ left: Math.max(0, target || 0), behavior: scrollBehaviour() });
    }

    prev.addEventListener('click', function () { step(-1, prev); });
    next.addEventListener('click', function () { step(1, next); });
    scroller.addEventListener('scroll', scheduleUpdate, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(scheduleUpdate).observe(scroller);
    } else {
      window.addEventListener('resize', scheduleUpdate);
    }

    update();
  }

  function fetchCandidates(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        return Array.prototype.slice.call(html.querySelectorAll('[data-mm-dis-results] > li'));
      })
      .catch(function () { return []; });
  }

  // The rules (data-mm-dis-related-rules) run together, then the cards are taken rule by rule, closest price
  // first within each rule, until the section's limit. A product shows once and this product never.
  function initRelated(root) {
    if (root.hasAttribute('data-mm-dis-ready')) return;
    root.setAttribute('data-mm-dis-ready', '');

    var list = root.querySelector('[data-mm-dis-related-list]');
    var productId = root.getAttribute('data-product-id');
    var price = parseInt(root.getAttribute('data-price'), 10) || 0;
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 16;
    var rules = [];

    try {
      rules = JSON.parse(root.querySelector('[data-mm-dis-related-rules]').textContent);
    } catch (error) {
      return;
    }

    Promise.all(rules.map(function (rule) { return fetchCandidates(rule.url); }))
      .then(function (results) {
        var shown = {};
        var added = 0;
        shown[productId] = true;

        rules.forEach(function (rule, ruleIndex) {
          var fromRule = 0;

          results[ruleIndex]
            .map(function (item, index) {
              return { item: item, index: index, distance: Math.abs((parseInt(item.getAttribute('data-price'), 10) || 0) - price) };
            })
            .sort(function (a, b) { return a.distance - b.distance || a.index - b.index; })
            .forEach(function (entry) {
              var id = entry.item.getAttribute('data-product-id');
              if (added >= limit || fromRule >= rule.limit || shown[id]) return;
              shown[id] = true;
              list.appendChild(document.importNode(entry.item, true));
              fromRule++;
              added++;
            });
        });

        root.setAttribute('data-mm-dis-count', String(added));
        if (!added) return;
        root.hidden = false;
        setupRelatedArrows(root);
      });
  }

  /* -------------------------------------------------------------------- Boot */

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mm-dis-gallery]'), initGallery);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mm-dis]'), initOptions);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mm-dis-features]'), initFeatures);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mm-dis-related]'), initRelated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: a re-rendered section starts again; a removed slider stops its timers
  document.addEventListener('shopify:section:load', function (event) {
    Array.prototype.forEach.call(event.target.querySelectorAll('[data-mm-dis-features]'), initFeatures);
    Array.prototype.forEach.call(event.target.querySelectorAll('[data-mm-dis-related]'), initRelated);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    Array.prototype.forEach.call(event.target.querySelectorAll('[data-mm-dis-features]'), function (section) {
      if (section.mmDisDestroy) section.mmDisDestroy();
    });
  });
})();
